import { EXPERIMENTS, FEATURE_FLAGS } from '@/lib/consts.js'

export const APP_DOMAIN = 'provider'

export const SUBJECT_TYPES = {
  BUSINESS_ID: 'business_id',
  FINGERPRINT: 'fingerprint',
}

export const FLAG_TYPES = {
  BOOL: 'bool',
  STRING: 'string',
  INTEGER: 'integer',
}

export const EppoFeatureFlags = {
  [FEATURE_FLAGS.Maintenance_Mode]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: 'disabled',
  },
  // PxCalendar - firestore integration
  [FEATURE_FLAGS.Feature_ProviderFirestore]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_CalendarFirestoreIntegration]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ProviderFirestorePersistentCache]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_CalendarFirestoreReduceApiCalls]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  // end PxCalendar - firestore integration

  [FEATURE_FLAGS.Feature_BoostAppointmentBlockClientDeleting]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_CalendarImport]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_QuickCardEntryOnCheckout]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: true,
  },

  [FEATURE_FLAGS.Feature_KeyedInPaymentOnBusinessAppointment]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: true,
  },

  [FEATURE_FLAGS.Feature_NSPFixedPrize]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_IterableEmbeddedMessaging]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Logging_Booksy_Unresponsive_Message]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_BoostLandingPage]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_PublicBusinessEmail]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },

  [FEATURE_FLAGS.Feature_EffortlessKYCAfterEkranZBaba]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BgcPaymentAndCheckoutTile]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Refactor_CustomConsentsKycMicroservice]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_FinancialCenter]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyWalletForStaffers]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ForceConfirmBillingInvoiceDataFlag]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PeakHours]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.PortfolioInstagram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_StorePermissions]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_NewInvoicingProcessIE]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BoostAppointmentDeletedUser]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_NethoneEnabled]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SplitSignUpAndLogin]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BarbersShareProfileAfterInvite]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_GoogleBusinessProfile]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_GoogleBusinessProfileVerification]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BooksyPayOnboardingRefunds]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_DynamicBoostWarning]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_RequestRefundPOSv2]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_WebinarInfobox]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.LoyaltyProgram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ReferAFriend]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PartialRefund]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_VisibilityPromotionMVP]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Refactor_BvcInput]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_PlatformFee]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ExtoleReferralDiscount]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SettingsGooglePlacesV3]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_JumpstartChallenge]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BuyersDataForVersum]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BoostNextPayment]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_VisibilityPromotionMVPStats]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_RelocateLoyaltyProgramTile]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ShowBadgeNewOnLoyaltyProgram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Experiment_BoostAppointmentCancellation]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_MicroFrontendInventory]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_UseNewTransactionDetailsGet]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_TurnTracker]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_SwitchBoostToVisibilityFrontend]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_NewOnlineBookingInstagram]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce_Modal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_Ecommerce_Holiday_Modal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_WalkthroughBGC]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BlackFridayBanner]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_LoyaltyBannerOnMarketing]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_ProductSuggestionsModal]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [FEATURE_FLAGS.Feature_BusinessPhoneVerificationFlag]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.FINGERPRINT,
    defaultValue: false,
  },
}

export const EppoExperiments = {
  [EXPERIMENTS.Experiment_ServicesFromWebsite]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ChurnPauseButton]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ChurnPauseButton]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_PeakHours]: {
    type: FLAG_TYPES.BOOL,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: false,
  },
  [EXPERIMENTS.Experiment_OtherCategoriesShareProfileAfterInvite]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_OnboardingGooglePlacesV3]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_IssueLoyaltyCardsAutomaticallyToNewAndExistingClients]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_OnboardingTestAppointment]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ReplaceProfileCompleteness]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_NewShareProfile]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ConnectServicesWithAddons]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_SocialPostCreatorFlowChange]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_NewProfileView]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_JumpstartChallange]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
  [EXPERIMENTS.Experiment_ShareLoyaltyProgram]: {
    type: FLAG_TYPES.STRING,
    subjectType: SUBJECT_TYPES.BUSINESS_ID,
    defaultValue: 'control',
  },
}
